import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'

import router from './router'
import store from './vuex'
import axios from './axios'
import locales from './locales'

import errorHandling from './errorHandling.js'

import 'babel-polyfill'
// import './vuetify'
import vuetify from './plugins/vuetify';

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

import moment from 'moment'
import clone from 'clone'

import VueTranslate from 'vue-translate-plugin'

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E',
    libraries: 'places',
  },
});

Vue.use(VueTranslate);
Vue.locales(locales);

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$clone = clone;

Vue.component('vue-headful', vueHeadful);
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
